import * as Yup from 'yup';

export const isEmail = (val: string) => /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i.test(val);
export const isUrl = (val: string) => urlRegex.test(val);
export const urlRegex =
  /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;

export const phoneRegExp = /1?\W*([2-9][0-8][0-9])\W*([2-9][0-9]{2})\W*([0-9]{4})(\se?x?t?(\d*))?/;
export const passwordRegex = new RegExp(
  /^(?=.*[A-Z])(?=.*[A-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])\S{10,20}$/
);
export const yupPhoneValidation = () =>
  Yup.string().matches(phoneRegExp, {
    excludeEmptyString: true,
    message: 'Invalid phone number'
  });

export const yupEmailValdation = () => Yup.string().email('Invalid Email');
export const yupRequiredString = () => Yup.string().required('Required');
